<template>
  <div class="field-row d-flex align-center ga-6 w-100 mb-4">
    <div class="field-col-field field-name-cell d-flex align-center ga-2">
      <JobProfileDragHandle
        label="Reorder field"
        :disabled="disabled"
      />
      <span class="field-order text-body-3 text-textLight">{{ field.order + 1 }}</span>
      <span class="field-name text-h2 text-textDarkest">{{ field.name }}</span>
    </div>
    <div class="field-col-visibility d-flex align-center">
      <DpplSlimSwitch
        :model-value="!field.is_hidden"
        :label="field.is_hidden ? 'Hide' : 'Show'"
        active-color="brand"
        :disabled="disabled"
        a11y-label-text="Element visibility"
        @update:model-value="emit('update:visible', $event)"
      />
    </div>
    <div class="field-col-status d-flex align-center">
      <DpplSlimSwitch
        :model-value="field.is_required"
        :disabled="field.is_hidden || disabled"
        :label="field.is_required ? 'Required' : 'Not required'"
        active-color="secondary"
        a11y-label-text="Element required status"
        @update:model-value="emit('update:required', $event)"
      />
    </div>
  </div>
</template>

<script setup>
import DpplSlimSwitch from '@/components/datapeople/DpplSlimSwitch.vue';
import JobProfileDragHandle from '@/components/settings/components/JobProfileDragHandle.vue';

defineProps({
  field: { type: Object, required: true },
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits(['update:visible', 'update:required']);
</script>

<style scoped lang="less">
.field-row {
  box-sizing: border-box;
}

.field-col-field {
  flex: 0 0 300px;
  width: 300px;
  min-width: 0;
}

.field-col-visibility {
  flex: 0 0 100px;
  width: 100px;
}

.field-col-status {
  flex: 1 1 auto;
  min-width: 0;
}

.field-order {
  min-width: 1.25rem;
  flex-shrink: 0;
}

.field-name {
  min-width: 0;
}
</style>
